import { DestinationInfo } from "./DestinationInfo";
import { BusinessDestinationInfo } from "./BusinessDestinationInfo";
import { MemberType } from "./MemberType";

// TODO: 置き場とファイルの内容整理
// 判別用 Type Guard: BusinessDestinationInfo かどうか
export function isBusinessDestinationInfo(value: any): value is BusinessDestinationInfo {
  return !!value && typeof value === "object" && (
    value.type === "Business" || value.type === MemberType?.Business
  ) && typeof value.companyName === "string";
}

// 判別用 Type Guard: 汎用 DestinationInfo（Business を除外）かどうか
export function isDestinationInfo(value: any): value is DestinationInfo {
  if (!value || typeof value !== "object") return false;
  if (isBusinessDestinationInfo(value)) return false; // Business は除外
  return "firstname" in value && "lastname" in value && "zipcode" in value && "type" in value;
}

// 種別取得ユーティリティ
export function getDestinationKind(value: any): "business" | "destination" | "unknown" {
  if (isBusinessDestinationInfo(value)) return "business";
  if (isDestinationInfo(value)) return "destination";
  return "unknown";
}

// アサーション関数
export function assertBusinessDestination(value: any): asserts value is BusinessDestinationInfo {
  if (!isBusinessDestinationInfo(value)) {
    throw new Error("Value is not BusinessDestinationInfo");
  }
}

export function assertDestination(value: any): asserts value is DestinationInfo {
  if (!isDestinationInfo(value)) {
    throw new Error("Value is not DestinationInfo");
  }
}
